import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import type { ColorType } from "../../themes/common";

const Divider = styled.div<SpaceProps & { colorName?: ColorType }>`
    border-bottom: 1px solid ${({ theme, colorName }) => theme.color[colorName || "grey2"]};
    ${space};
`;

export default Divider;
